'use client';
import * as React from 'react';
import { cn } from '../cn';

export interface SidebarProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}
export function Sidebar({ children, header, footer, className }: SidebarProps) {
  return (
    <aside className={cn('glass hairline-r flex h-full w-[248px] shrink-0 flex-col', className)}>
      {header ? <div className="px-4 pt-4 pb-2">{header}</div> : null}
      <nav className="flex-1 overflow-y-auto px-3 py-2 flex flex-col gap-0.5">{children}</nav>
      {footer ? <div className="px-3 py-3 hairline-t">{footer}</div> : null}
    </aside>
  );
}

export function NavSection({ label, children }: { label?: string; children: React.ReactNode }) {
  return (
    <div className="mt-3 first:mt-0">
      {label ? <div className="px-2.5 pb-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-text-3">{label}</div> : null}
      <div className="flex flex-col gap-0.5">{children}</div>
    </div>
  );
}

export interface NavItemProps {
  href: string;
  icon?: React.ReactNode;
  label: React.ReactNode;
  active?: boolean;
  badge?: React.ReactNode;
  linkComponent?: React.ComponentType<{ href: string; className?: string; children?: React.ReactNode; 'aria-current'?: 'page' }>;
  onClick?: () => void;
}
export function NavItem({ href, icon, label, active, badge, linkComponent, onClick }: NavItemProps) {
  const Link = linkComponent ?? (({ href, className, children, ...rest }) => (
    <a href={href} className={className} {...rest}>
      {children}
    </a>
  ));
  return (
    <Link href={href} aria-current={active ? 'page' : undefined} className={cn('group flex items-center gap-2.5 h-8 px-2.5 rounded-[var(--radius-sm)] text-[13.5px] font-medium transition-colors', active ? 'bg-accent-tint text-accent' : 'text-text-2 hover:bg-fill-3 hover:text-text')}>
      <span onClick={onClick} className="contents">
        {icon ? <span className={cn('[&>svg]:size-[18px] inline-flex shrink-0', active ? 'text-accent' : 'text-text-3 group-hover:text-text-2')}>{icon}</span> : null}
        <span className="truncate flex-1">{label}</span>
        {badge ? <span className="shrink-0">{badge}</span> : null}
      </span>
    </Link>
  );
}
